import React from "react";
import {Box, Columns, Table} from "react-bulma-components";
import Collapsible from "react-collapsible";
import InvoiceSectionRow from "./InvoiceSectionRow";


export default function InvoiceSection({invoices}){


    return (
        <Box>
            <Collapsible
                trigger={"Invoices"}
                triggerOpenedClassName={"title"}
                className={"title"}
            >
                <Columns>
                    <Columns.Column>
                        <Table size={"fullwidth"}>
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>Quantity</th>
                                    <th>Amount</th>
                                    <th>No Vat Amount</th>
                                    <th>Invoice Date</th>
                                    <th>Invoice Number</th>
                                    <th>Approved</th>
                                    <th>Approver</th>
                                    <th>Description</th>
                                    <th>Comments</th>
                                    <th>Hidden</th>
                                </tr>
                            </thead>
                            <tbody>
                                {invoices.map(invoice => (
                                    <InvoiceSectionRow
                                        invoice={invoice}
                                    />
                                ))}
                            </tbody>
                        </Table>
                    </Columns.Column>
                </Columns>
            </Collapsible>
        </Box>
    )


}